import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-5" data-id="element-73" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-2xl border border-brand-line bg-brand-cream p-3.5 shadow-sm" data-id="element-74" data-mp="1o33s8bhenif4">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-75" data-mp="1x4bsv07e8vcd" />
        <div data-id="element-76" data-mp="1x2ik9fd8011q">
          <h2 className="mb-1 font-display text-base font-extrabold uppercase leading-tight sm:text-xl" data-id="element-77" data-mp="19eqyll5sibns">
            Il tuo acquisto è protetto al 100%
          </h2>
          <p className="text-xs font-medium leading-snug text-brand-muted sm:text-base" data-id="element-78" data-mp="14hh965iehzzy">
            Hai 14 giorni completi per esplorare SMART HOME PRO™, studiare i moduli, utilizzare le
            checklist, seguire le procedure, analizzare gli esempi e iniziare ad applicare il
            sistema. Se durante questo periodo decidi che SMART HOME PRO™ non fa per te, contattaci
            entro i primi 14 giorni e riceverai il rimborso del 100% del tuo acquisto. Senza rischi.
          </p>
        </div>
      </div>
    </section>;
}